/**
 * @deprecated This Redux slice is deprecated. Use RTK Query instead:
 * - Import from: `redux/services/drivers/driversApi`
 * - Queries: `useGetDriversQuery`, `useGetDriverQuery`
 * - Mutations: `useCreateDriverMutation`, `useUpdateDriverMutation`, `useDeleteDriversMutation`
 *
 * This slice is maintained for backward compatibility only and will be removed in future versions.
 */
import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import request, { renderQueries } from "../../../utils/request";

const ROOT = "http://localhost:8080/api/v1";

const initialState = {
  drivers: [],
  status: "idle",
  error: null,
};

/**
 * @deprecated Use `useGetDriversQuery` from `redux/services/drivers/driversApi` instead
 */
export const fetchDrivers = createAsyncThunk(
  "drivers/fetchDrivers",
  async (obj, { rejectWithValue }) => {
    const queries = renderQueries(obj);
    const res = await request(`/drivers?${queries}`);
    if (!res.data.drivers) {
      rejectWithValue(res.data);
      return;
    }
    return res.data;
  }
);

export const driversSlice = createSlice({
  name: "drivers",
  initialState,
  reducers: {
    resetDrivers: () => initialState,
    setDrivers(state, action) {
      state.drivers = action.payload;
    },
    driverAdded(state, action) {
      // Handle different response structures (user, data, or direct object)
      const driver =
        action.payload.user || action.payload.data || action.payload;
      // Only add if we have a valid driver object
      if (driver && driver._id) {
        state.drivers = state.drivers.concat(driver);
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchDrivers.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchDrivers.fulfilled, (state, action) => {
        state.drivers = [];
        state.status = "succeeded";
        state.drivers = state.drivers.concat(action.payload.drivers);
      })
      .addCase(fetchDrivers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { resetDrivers, setDrivers, driverAdded } = driversSlice.actions;

export default driversSlice.reducer;

/**
 * @deprecated Use RTK Query `useGetDriversQuery` and transform the data instead
 */
export const selectAllDrivers = (state) => state.drivers.drivers;

/**
 * @deprecated Use RTK Query `useGetDriversQuery` and transform the data instead
 * Example:
 * ```
 * const { data } = useGetDriversQuery({ page: 1, limit: 100 });
 * const options = data?.drivers?.map(d => ({ label: d.fullName, value: d })) || [];
 * ```
 */
export const driverSelectOptions = (state) =>
  (state.drivers.drivers || [])
    .filter((obj) => obj && obj.fullName) // Filter out any undefined/null entries
    .map((obj) => ({
      label: obj.fullName,
      value: obj,
    }));
